import { useReviewStats } from "@/hooks/useReviewStats";

export function TrustBadgeTicker() {
  const { totalPlusLabel } = useReviewStats();
  const badges = [
    { text: "5-Star Google Rated", icon: "google" },
    { text: "5-Star Yelp Rated", icon: "yelp" },
    { text: "Fully Insured", icon: "shield" },
    { text: "Satisfaction Guaranteed", icon: "check" },
    { text: `${totalPlusLabel} Five-Star Reviews`, icon: "star" },
    { text: "Same-Day Service Available", icon: "clock" },
    { text: "Free Estimates", icon: "dollar" },
    { text: "Newport Beach Based", icon: "pin" },
  ];

  const doubled = [...badges, ...badges];

  return (
    <section className="bg-slate-900 py-4 overflow-hidden" data-testid="trust-ticker">
      <div className="flex animate-ticker" style={{ width: 'max-content' }}>
        {doubled.map((badge, idx) => (
          <div key={idx} className="flex items-center gap-2 mx-8 whitespace-nowrap">
            <span className="text-orange-400 text-lg">
              {badge.icon === "google" && "★"}
              {badge.icon === "yelp" && "★"}
              {badge.icon === "shield" && "✓"}
              {badge.icon === "check" && "✓"}
              {badge.icon === "star" && "★"}
              {badge.icon === "clock" && "⚡"}
              {badge.icon === "dollar" && "$"}
              {badge.icon === "pin" && "📍"}
            </span>
            <span className="text-white text-sm font-medium tracking-wide">{badge.text}</span>
          </div>
        ))}
      </div>
      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-ticker {
          animation: ticker 30s linear infinite;
        }
      `}</style>
    </section>
  );
}
